import Raven from "raven-js"
import backpackMixin from "./backpack"
import { CLICK, PAGE_VIEW } from "../../../../constants/report-dictonary"
import { getInventoryByMenuId, getPropsByMenuId } from "../../../../business/backpack"
import Share from "../../backpack/Share.vue"
import TopNav from "../../backpack/TopNav.vue"
import { USER_HELPER } from "../../../../constants/error_map"
import { mapActions } from "vuex"
import { every } from "lodash"
import BackpackApi from "../../../../api/backpack"
import { showCgiError } from "@tencent/midas-cgi"

export default {
  components: {
    Share,
    TopNav
  },

  mixins: [backpackMixin],

  computed: {
    /**
     * 分享文案
     * @returns {string}
     */
    shareCount() {
      let count = 0
      if (this.inventory?.list?.length) {
        count = this.inventory.list.filter(item => item.inbag).length
      }

      return count
    },

    /**
     * 进度文案
     * @returns {string}
     */
    processText() {
      if (this.inventory?.list) {
        return `${this.inventory.list.filter(item => item.inbag).length}/${this.inventory.list.length}`
      }

      return ""
    },

    /**
     * 是否皮肤都已经解锁
     * @returns {boolean}
     */
    processFinished() {
      if (this.inventory?.list?.length) {
        return every(this.inventory.list, item => {
          return item.inbag
        })
      }

      return false
    }
  },

  data() {
    return {
      inventory: [],
      showShare: false,
      displayShareProps: [],
      menuId: ""
    }
  },

  methods: {
    ...mapActions(["goToOrderPage"]),
    /**
     * 初始化页面数据
     * 避免从别处路由时使用上次数据
     */
    initData() {
      this.errInfo = null
      this.showShare = false
      this.displayShareProps = []
      this.inventory = []
    },

    /**
     * 初始化接口请求信息
     * 1、获取业务信息
     * 2、获取道具列表
     * 3、获取缓存大区
     * 4、获取背包列表
     * 5、通过背包列表获得背包状态
     */
    async initStoreZoneInfo(cb) {
      this.setLoadingStart()

      try {
        await this.initBaseInfo()
      } catch (e) {
        this.setAndReportErr(e)
        return
      }

      // 获取背包列表
      this.renderInventory()

      cb && cb()
    },

    /**
     * 渲染列表信息
     */
    async renderInventory() {
      this.initData()

      this.setLoadingStart()

      this.menuId = this.$route.query.menuId

      if (!this.menuId) {
        return this.setAndReportErr(new Error("empty menu"))
      }

      // 当前菜单下的道具列表
      const propList = getPropsByMenuId(this.vmallGoodsList, this.menuId)
      let subjectIds = propList
        ?.map(item => item.itemExtend?.AMSID)
        .filter(item => item)
        .join(",")

      // 获取背包列表,此处若获取失败，仅提示用户，因为系列皮肤仍可展示给用户
      let backpackIdList = []
      try {
        backpackIdList = await this.setBackpackIdListBySubjectIds(subjectIds)
      } catch (e) {
        this.setToastMsg(USER_HELPER.SYSTEM_BUSY)
        this.reportToRaven(e)
      }

      this.inventory = getInventoryByMenuId(this.menuId, propList, this.currentItem, backpackIdList)

      // 虎年限定的菜单不需要去调用评分等状态查询接口
      if (this.menuId !== "ME2022011716424198860316") {
        this.setBackPackListStatus(subjectIds)
        // 预渲染base64图片
      }

      this.preRenderShareImages()

      this.setLoadingEnd()

      this.errInfo = null

      // 全部集齐时，需要上报
      if (this.inventory?.list.every(item => item.inbag)) {
        this.reportUserAction({
          iformat: PAGE_VIEW.BACKPACK_NEW_YEAR_FULL,
          resultInfo: {
            type: this.menuId
          }
        })
      }
    },

    /**
     * 设置用户背包列表
     */
    async setBackpackIdListBySubjectIds(subjectIds) {
      // 用户未选择大区
      if (!this.userZoneInfo?.zoneName) {
        this.setToastMsg(USER_HELPER.NO_SELECTED_ZONE)
        return
      }

      let offerId = this.currentItem?.ams?.offerid
      let backpackApi = new BackpackApi({
        pf: this.pf,
        sandbox: this.sandbox,
        sessionObj: this.sessionObj,
        offerId
      })

      // 获得背包返回的cgi结果
      let res = await backpackApi.queryBackpackListBySubjectIds({
        ...this.zoneParams,
        subject_id: subjectIds
      })

      if (res.ret !== 0) {
        throw new Error(showCgiError(res))
      }

      return Object.keys(res.data).filter(item => res.data[item])
    },

    /**
     * 分享弹窗的显示与关闭
     */
    toggleShareDialog() {
      this.showShare = !this.showShare

      if (this.showShare) {
        this.reportUserAction({
          iformat: CLICK.BACKPACK_INVENTORY_SHARE,
          pfStructure: this.$route.query.pfStructure,
          resultInfo: {
            type: this.menuId
          }
        })
      }
    },

    /**
     * 判断物品是否在背包内
     * 若在背包内则跳转到背包详情页
     * 若不在背包内则跳转到购买页，提升购买转换率
     */
    goToDetail(prop, index) {
      if (prop.inbag) {
        this.$router.push({
          name: "BackpackDetail",
          params: {
            bizgroupid: this.groupId,
            bizid: this.busId,
            goodsid: prop.itemExtend?.AMSID
          },
          query: this.$route.query
        })
      } else {
        this.goToPropDetail({
          prop,
          routeQuery: this.$route.query
        })
      }

      this.reportUserAction({
        iformat: CLICK.BACKPACK_INVENTORY_GOODS,
        resultInfo: {
          prouductId: prop.itemExtend?.AMSID,
          type: this.menuId,
          index,
          subjectType: prop.inbag ? 1 : 0
        }
      })
    },

    /**
     * 跳转到商城页面
     */
    goToOrder() {
      let { groupId, busId } = this.currentItem
      this.goToOrderPage({
        groupId,
        busId,
        query: this.$route.query
      })

      this.reportUserAction({
        iformat: CLICK.BACKPACK_INVENTORY_BUY,
        resultInfo: {
          type: this.menuId
        }
      })
    },

    /**
     * 上报错误
     * @param err
     */
    reportToRaven(err) {
      Raven.captureException(err, {
        tags: { type: "err in backpackinventory" }
      })
    },

    /**
     * 切换大区
     */
    changeZone() {
      this.clickZoneAndRoleSelector(async () => {
        this.setLoadingStart()

        await this.renderInventory()

        this.setLoadingEnd()
      })
    }
  }
}
